var React = require('react');

function PlusCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"10","key":0}),React.createElement("line",{"x1":"12","y1":"8","x2":"12","y2":"16","key":1}),React.createElement("line",{"x1":"8","y1":"12","x2":"16","y2":"12","key":2})]);
}

PlusCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-plus-circle"};

module.exports = PlusCircle;

PlusCircle.default = PlusCircle;
